import React, { FC } from 'react';

const Loader: FC = () => {
  return(
    <div className="loader-wrapper">
      <div className="custom-loader"></div>
    </div>
  );
}

export default Loader;